var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"exclude":"TljDetail"}},[_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title || 'Loading...'),expression:"$route.meta.title || 'Loading...'"}]})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }